import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Logo } from "@/components/Logo";
import { scrollToId, startCheckout } from "@/lib/api";

const LINKS = [
  { label: "Il Metodo", id: "metodo" },
  { label: "Contenuti", id: "contenuti" },
  { label: "Il Quiz", id: "quiz" },
  { label: "FAQ", id: "faq" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const buy = async () => {
    setLoading(true);
    try {
      await startCheckout();
    } finally {
      setLoading(false);
    }
  };

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-linen/85 backdrop-blur-xl border-b border-ink/5" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 sm:px-8">
        <Logo />
        <nav className="hidden items-center gap-8 lg:flex">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => scrollToId(l.id)}
              className="text-sm font-medium text-taupe transition-colors hover:text-terracotta"
            >
              {l.label}
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <Link
            to="/area-riservata"
            data-testid="nav-login-button"
            className="hidden rounded-full border border-ink/15 px-5 py-2 text-sm font-semibold text-ink transition-colors hover:border-terracotta hover:text-terracotta sm:block"
          >
            Accedi
          </Link>
          <button
            onClick={buy}
            disabled={loading}
            data-testid="nav-buy-button"
            className="rounded-full bg-terracotta px-5 py-2 text-sm font-semibold text-linen shadow-lg shadow-terracotta/25 transition-all hover:bg-terracotta-dark hover:shadow-terracotta/40 disabled:opacity-60"
          >
            {loading ? "Attendi…" : "Inizia oggi · €29"}
          </button>
        </div>
      </div>
    </motion.header>
  );
};
